import { render, staticRenderFns } from "./v-field-readonly.vue?vue&type=template&id=050599ef"
import script from "./v-field-readonly.vue?vue&type=script&lang=js"
export * from "./v-field-readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports